/* tslint:disable */
/* eslint-disable */
/**
 * Web IMD-CONNECT.PRO
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { AdditionalCosts } from '../models';
// @ts-ignore
import { Company } from '../models';
// @ts-ignore
import { RentalCarDatPricing } from '../models';
// @ts-ignore
import { RentalCarRepairShopPricing } from '../models';
// @ts-ignore
import { ZipCodeArea } from '../models';
/**
 * RentalCarsApi - axios parameter creator
 * @export
 */
export const RentalCarsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get a Company List by Zip-Code Areas
         * @param {string} zipcodearea 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rentalcarpricingDatCompanylistZipcodeareaGet: async (zipcodearea: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'zipcodearea' is not null or undefined
            assertParamExists('rentalcarpricingDatCompanylistZipcodeareaGet', 'zipcodearea', zipcodearea)
            const localVarPath = `/rentalcarpricing/dat/companylist/{zipcodearea}`
                .replace(`{${"zipcodearea"}}`, encodeURIComponent(String(zipcodearea)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get DAT Pricings
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rentalcarpricingDatGet: async (id?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rentalcarpricing/dat`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get additional prices
         * @param {number} [companyId] The id of the company to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rentalcarpricingDatNebenkostenGet: async (companyId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rentalcarpricing/dat/nebenkosten`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required

            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update additional prices
         * @param {number} [companyId] The id of the company to retrieve
         * @param {AdditionalCosts} [additionalCosts] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rentalcarpricingDatNebenkostenPut: async (companyId?: number, additionalCosts?: AdditionalCosts, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rentalcarpricing/dat/nebenkosten`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required

            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(additionalCosts, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update RentalCar Pricings
         * @param {RentalCarDatPricing} [rentalCarDatPricing] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rentalcarpricingDatPut: async (rentalCarDatPricing?: RentalCarDatPricing, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rentalcarpricing/dat`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rentalCarDatPricing, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get List by Zip-Code Areas
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rentalcarpricingDatZipcodeareasGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rentalcarpricing/dat/zipcodeareas`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get RentalCar Pricings
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rentalcarpricingGet: async (id?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rentalcarpricing`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update RentalCar Pricings
         * @param {RentalCarRepairShopPricing} [rentalCarRepairShopPricing] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rentalcarpricingPut: async (rentalCarRepairShopPricing?: RentalCarRepairShopPricing, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rentalcarpricing`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rentalCarRepairShopPricing, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RentalCarsApi - functional programming interface
 * @export
 */
export const RentalCarsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RentalCarsApiAxiosParamCreator(configuration)
    return {
        /**
         * Get a Company List by Zip-Code Areas
         * @param {string} zipcodearea 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rentalcarpricingDatCompanylistZipcodeareaGet(zipcodearea: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Company>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rentalcarpricingDatCompanylistZipcodeareaGet(zipcodearea, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get DAT Pricings
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rentalcarpricingDatGet(id?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RentalCarDatPricing>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rentalcarpricingDatGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get additional prices
         * @param {number} [companyId] The id of the company to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rentalcarpricingDatNebenkostenGet(companyId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdditionalCosts>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rentalcarpricingDatNebenkostenGet(companyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update additional prices
         * @param {number} [companyId] The id of the company to retrieve
         * @param {AdditionalCosts} [additionalCosts] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rentalcarpricingDatNebenkostenPut(companyId?: number, additionalCosts?: AdditionalCosts, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdditionalCosts>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rentalcarpricingDatNebenkostenPut(companyId, additionalCosts, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update RentalCar Pricings
         * @param {RentalCarDatPricing} [rentalCarDatPricing] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rentalcarpricingDatPut(rentalCarDatPricing?: RentalCarDatPricing, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RentalCarDatPricing>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rentalcarpricingDatPut(rentalCarDatPricing, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get List by Zip-Code Areas
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rentalcarpricingDatZipcodeareasGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ZipCodeArea>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rentalcarpricingDatZipcodeareasGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get RentalCar Pricings
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rentalcarpricingGet(id?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RentalCarRepairShopPricing>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rentalcarpricingGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update RentalCar Pricings
         * @param {RentalCarRepairShopPricing} [rentalCarRepairShopPricing] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rentalcarpricingPut(rentalCarRepairShopPricing?: RentalCarRepairShopPricing, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RentalCarRepairShopPricing>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rentalcarpricingPut(rentalCarRepairShopPricing, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RentalCarsApi - factory interface
 * @export
 */
export const RentalCarsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RentalCarsApiFp(configuration)
    return {
        /**
         * Get a Company List by Zip-Code Areas
         * @param {string} zipcodearea 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rentalcarpricingDatCompanylistZipcodeareaGet(zipcodearea: string, options?: any): AxiosPromise<Array<Company>> {
            return localVarFp.rentalcarpricingDatCompanylistZipcodeareaGet(zipcodearea, options).then((request) => request(axios, basePath));
        },
        /**
         * Get DAT Pricings
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rentalcarpricingDatGet(id?: number, options?: any): AxiosPromise<Array<RentalCarDatPricing>> {
            return localVarFp.rentalcarpricingDatGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get additional prices
         * @param {number} [companyId] The id of the company to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rentalcarpricingDatNebenkostenGet(companyId?: number, options?: any): AxiosPromise<AdditionalCosts> {
            return localVarFp.rentalcarpricingDatNebenkostenGet(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update additional prices
         * @param {number} [companyId] The id of the company to retrieve
         * @param {AdditionalCosts} [additionalCosts] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rentalcarpricingDatNebenkostenPut(companyId?: number, additionalCosts?: AdditionalCosts, options?: any): AxiosPromise<AdditionalCosts> {
            return localVarFp.rentalcarpricingDatNebenkostenPut(companyId, additionalCosts, options).then((request) => request(axios, basePath));
        },
        /**
         * Update RentalCar Pricings
         * @param {RentalCarDatPricing} [rentalCarDatPricing] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rentalcarpricingDatPut(rentalCarDatPricing?: RentalCarDatPricing, options?: any): AxiosPromise<RentalCarDatPricing> {
            return localVarFp.rentalcarpricingDatPut(rentalCarDatPricing, options).then((request) => request(axios, basePath));
        },
        /**
         * Get List by Zip-Code Areas
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rentalcarpricingDatZipcodeareasGet(options?: any): AxiosPromise<Array<ZipCodeArea>> {
            return localVarFp.rentalcarpricingDatZipcodeareasGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Get RentalCar Pricings
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rentalcarpricingGet(id?: number, options?: any): AxiosPromise<Array<RentalCarRepairShopPricing>> {
            return localVarFp.rentalcarpricingGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Update RentalCar Pricings
         * @param {RentalCarRepairShopPricing} [rentalCarRepairShopPricing] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rentalcarpricingPut(rentalCarRepairShopPricing?: RentalCarRepairShopPricing, options?: any): AxiosPromise<RentalCarRepairShopPricing> {
            return localVarFp.rentalcarpricingPut(rentalCarRepairShopPricing, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RentalCarsApi - object-oriented interface
 * @export
 * @class RentalCarsApi
 * @extends {BaseAPI}
 */
export class RentalCarsApi extends BaseAPI {
    /**
     * Get a Company List by Zip-Code Areas
     * @param {string} zipcodearea 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RentalCarsApi
     */
    public rentalcarpricingDatCompanylistZipcodeareaGet(zipcodearea: string, options?: AxiosRequestConfig) {
        return RentalCarsApiFp(this.configuration).rentalcarpricingDatCompanylistZipcodeareaGet(zipcodearea, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get DAT Pricings
     * @param {number} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RentalCarsApi
     */
    public rentalcarpricingDatGet(id?: number, options?: AxiosRequestConfig) {
        return RentalCarsApiFp(this.configuration).rentalcarpricingDatGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get additional prices
     * @param {number} [companyId] The id of the company to retrieve
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RentalCarsApi
     */
    public rentalcarpricingDatNebenkostenGet(companyId?: number, options?: AxiosRequestConfig) {
        return RentalCarsApiFp(this.configuration).rentalcarpricingDatNebenkostenGet(companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update additional prices
     * @param {number} [companyId] The id of the company to retrieve
     * @param {AdditionalCosts} [additionalCosts] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RentalCarsApi
     */
    public rentalcarpricingDatNebenkostenPut(companyId?: number, additionalCosts?: AdditionalCosts, options?: AxiosRequestConfig) {
        return RentalCarsApiFp(this.configuration).rentalcarpricingDatNebenkostenPut(companyId, additionalCosts, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update RentalCar Pricings
     * @param {RentalCarDatPricing} [rentalCarDatPricing] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RentalCarsApi
     */
    public rentalcarpricingDatPut(rentalCarDatPricing?: RentalCarDatPricing, options?: AxiosRequestConfig) {
        return RentalCarsApiFp(this.configuration).rentalcarpricingDatPut(rentalCarDatPricing, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get List by Zip-Code Areas
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RentalCarsApi
     */
    public rentalcarpricingDatZipcodeareasGet(options?: AxiosRequestConfig) {
        return RentalCarsApiFp(this.configuration).rentalcarpricingDatZipcodeareasGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get RentalCar Pricings
     * @param {number} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RentalCarsApi
     */
    public rentalcarpricingGet(id?: number, options?: AxiosRequestConfig) {
        return RentalCarsApiFp(this.configuration).rentalcarpricingGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update RentalCar Pricings
     * @param {RentalCarRepairShopPricing} [rentalCarRepairShopPricing] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RentalCarsApi
     */
    public rentalcarpricingPut(rentalCarRepairShopPricing?: RentalCarRepairShopPricing, options?: AxiosRequestConfig) {
        return RentalCarsApiFp(this.configuration).rentalcarpricingPut(rentalCarRepairShopPricing, options).then((request) => request(this.axios, this.basePath));
    }
}
